/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.actuator = {};
    Blockly.Blocks.actuator.style = 'actuators_blocks';
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_led = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.ACTUATOR_LED)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_led.svg", 50, 50))
                .appendField(Blockly.Msg.ACTUATOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].digital),"PIN")
                .appendField(Blockly.Msg.ACTUATOR_STATUS)
                .appendField(new Blockly.FieldDropdown([
                    [Blockly.Msg.ACTUATOR_BOOLEAN_ON, "HIGH"],
                    [Blockly.Msg.ACTUATOR_BOOLEAN_OFF, "LOW"]
                    // ["%{BKY_LOGIC_BOOLEAN_ON}", "HIGH"],
                    // ["%{BKY_LOGIC_BOOLEAN_OFF}", "LOW"]
                ]), "STAT");
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_led_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.ACTUATOR_LED)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_led.svg", 50, 50))
                .appendField(Blockly.Msg.ACTUATOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].actuator_led),"PIN")
                .appendField(Blockly.Msg.ACTUATOR_STATUS)
                .appendField(new Blockly.FieldDropdown([
                    [Blockly.Msg.ACTUATOR_BOOLEAN_ON, "HIGH"],
                    [Blockly.Msg.ACTUATOR_BOOLEAN_OFF, "LOW"]
                    // ["%{BKY_LOGIC_BOOLEAN_ON}", "HIGH"],
                    // ["%{BKY_LOGIC_BOOLEAN_OFF}", "LOW"]
                ]), "STAT");
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_led_pwm = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.ACTUATOR_LED_PWM)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_led.svg", 50, 50))
                .appendField(Blockly.Msg.ACTUATOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN");
            this.appendValueInput("NUM", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.ACTUATOR_VALUE);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_led_pwm_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.ACTUATOR_LED_PWM)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_led.svg", 50, 50))
                .appendField(Blockly.Msg.ACTUATOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].PWM), "PIN");
            this.appendValueInput("NUM", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.ACTUATOR_VALUE);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_led_rgb_color_picker = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.ACTUATOR_RGBLED)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_rgb.svg", 50, 50))
                .appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.ACTUATOR_COMMON_CATHODE, "CC"],
                [Blockly.Msg.ACTUATOR_COMMON_ANODE, "CA"]]), "TYPE")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " R")
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN_R")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " G")
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN_G")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " B")
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN_B")
                .appendField(Blockly.Msg.ACTUATOR_COLOUR);
                this.appendValueInput("COLOUR", new Blockly.FieldColour("#ff0000"));
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null);
            this.setInputsInline(!0);
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_led_rgb_color_picker_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.ACTUATOR_RGBLED)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_rgb.svg", 50, 50))
                .appendField(new Blockly.FieldDropdown([
                    [Blockly.Msg.ACTUATOR_COMMON_CATHODE, "CC"],
                    [Blockly.Msg.ACTUATOR_COMMON_ANODE, "CA"]]), "TYPE")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " R")
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].PWM), "PIN_R")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " G")
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].PWM), "PIN_G")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " B")
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].PWM), "PIN_B")
                .appendField(Blockly.Msg.ACTUATOR_COLOUR);
            this.appendValueInput("COLOUR", new Blockly.FieldColour("#ff0000"));
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null);
            this.setInputsInline(!0);
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_led_rgb = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.ACTUATOR_RGBLED)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_rgb.svg", 50, 50))
                .appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.ACTUATOR_COMMON_CATHODE, "CC"],
                [Blockly.Msg.ACTUATOR_COMMON_ANODE, "CA"]]), "TYPE")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " R")
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN_R")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " G")
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN_G")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " B")
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN_B");
            this.appendValueInput("R", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField("R");
            this.appendValueInput("G", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField("G");
            this.appendValueInput("B", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField("B");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_led_rgb_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.ACTUATOR_RGBLED)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_rgb.svg", 50, 50))
                .appendField(new Blockly.FieldDropdown([
                    [Blockly.Msg.ACTUATOR_COMMON_CATHODE, "CC"],
                    [Blockly.Msg.ACTUATOR_COMMON_ANODE, "CA"]]), "TYPE")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " R")
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].PWM), "PIN_R")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " G")
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].PWM), "PIN_G")
                .appendField(Blockly.Msg.ACTUATOR_PIN + " B")
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].PWM), "PIN_B");
            this.appendValueInput("R", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField("R");
            this.appendValueInput("G", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField("G");
            this.appendValueInput("B", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField("B");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_buzzer = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.ACTUATOR_BUZZER)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_buzzer.svg", 50, 50))
                .appendField(Blockly.Msg.ACTUATOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN");
            this.appendValueInput("MS", "Number")
                .appendField(Blockly.Msg.ACTUATOR_BUZZER_DURATION)
                .setCheck("Number");
                this.appendDummyInput().appendField("ms ");

            this.appendValueInput("TONE", "Number")
                .appendField(Blockly.Msg.ACTUATOR_BUZZER_FREQ)
                .setCheck("Number");
                this.appendDummyInput().appendField("Hz");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_buzzer_tone = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.ACTUATOR_BUZZER)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_buzzer.svg", 50, 50));
            this.appendDummyInput()
                .appendField(Blockly.Msg.ACTUATOR_BUZZER_TONE + " (Hz)")
                .appendField(new Blockly.FieldImage(img_path + "arduino/note.svg", 30, 30))
                .appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.ACTUATOR_NOTE_C,  "523.26"],
                [Blockly.Msg.ACTUATOR_NOTE_CS, "554.37"],
                [Blockly.Msg.ACTUATOR_NOTE_D,  "587.33"],
                [Blockly.Msg.ACTUATOR_NOTE_DS, "622.25"],
                [Blockly.Msg.ACTUATOR_NOTE_E,  "659.26"],
                [Blockly.Msg.ACTUATOR_NOTE_F,  "698.46"],
                [Blockly.Msg.ACTUATOR_NOTE_FS, "739.99"],
                [Blockly.Msg.ACTUATOR_NOTE_G,  "783.99"],
                [Blockly.Msg.ACTUATOR_NOTE_GS, "830.61"],
                [Blockly.Msg.ACTUATOR_NOTE_A,  "880.00"],
                [Blockly.Msg.ACTUATOR_NOTE_AS, "932.33"],
                [Blockly.Msg.ACTUATOR_NOTE_B,  "987.77"]
            ]), "NOTE");
            this.setInputsInline(true);
            this.setOutput(true, "Number");
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_buzzer_tone_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.ACTUATOR_BUZZER)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_buzzer.svg", 50, 50))
                .appendField(Blockly.Msg.ACTUATOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].digital), "PIN")
                .appendField(Blockly.Msg.ACTUATOR_BUZZER_DURATION)
                .appendField(new Blockly.FieldNumber(), "S")
                .appendField("s ")
                .appendField(Blockly.Msg.ACTUATOR_BUZZER_TONE + " (Hz)")
                .appendField(new Blockly.FieldImage(img_path + "arduino/note.svg", 30, 30))
                .appendField(new Blockly.FieldDropdown([
                    [Blockly.Msg.ACTUATOR_NOTE_C,  "523.26"],
                    [Blockly.Msg.ACTUATOR_NOTE_CS, "554.37"],
                    [Blockly.Msg.ACTUATOR_NOTE_D,  "587.33"],
                    [Blockly.Msg.ACTUATOR_NOTE_DS, "622.25"],
                    [Blockly.Msg.ACTUATOR_NOTE_E,  "659.26"],
                    [Blockly.Msg.ACTUATOR_NOTE_F,  "698.46"],
                    [Blockly.Msg.ACTUATOR_NOTE_FS, "739.99"],
                    [Blockly.Msg.ACTUATOR_NOTE_G,  "783.99"],
                    [Blockly.Msg.ACTUATOR_NOTE_GS, "830.61"],
                    [Blockly.Msg.ACTUATOR_NOTE_A,  "880.00"],
                    [Blockly.Msg.ACTUATOR_NOTE_AS, "932.33"],
                    [Blockly.Msg.ACTUATOR_NOTE_B,  "987.77"]
                ]), "NOTE");

            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null);
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_buzzer_rttl = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.ACTUATOR_BUZZER)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_buzzer.svg", 50, 50))
                .appendField(Blockly.Msg.ACTUATOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN");
            this.appendDummyInput()
                .appendField(Blockly.Msg.ACTUATOR_SOUND_PLAY + " RTTTL");
            this.appendValueInput("RTTTL", "String")
                .setCheck("String")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_buzzer_rttl_melody = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.appendDummyInput()
                .appendField(Blockly.Msg.ACTUATOR_BUZZER)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_buzzer.svg", 50, 50));
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/rttl.svg", 30, 30))
                .appendField("RTTTL");
            //  https://picaxe.com/rtttl-ringtones-for-tune-command/
            this.appendDummyInput()
                .appendField(new Blockly.FieldDropdown([
                ["Tetris", ":d=4,o=5,b=160:e6,8b,8c6,8d6,16e6,16d6,8c6,8b,a,8a,8c6,e6,8d6,8c6,b,8b,8c6,d6,e6,c6,a,2a,8p,d6,8f6,a6,8g6,8f6,e6,8e6,8c6,e6,8d6,8c6,b,8b,8c6,d6,e6,c6,a,a"],
                ["Mario Bros", ":d=4,o=5,b=100:16e6,16e6,32p,8e6,16c6,8e6,8g6,8p,8g,8p,8c6,16p,8g,16p,8e,16p,8a,8b,16a#,8a,16g.,16e6,16g6,8a6,16f6,8g6,8e6,16c6,16d6,8b,16p,8c6,16p,8g,16p,8e,16p,8a,8b,16a#,8a,16g.,16e6,16g6,8a6,16f6,8g6,8e6,16c6,16d6,8b,8p,16g6,16f#6,16f6,16d#6,16p,16e6,16p,16g#,16a,16c6,16p,16a,16c6,16d6,8p,16g6,16f#6,16f6,16d#6,16p,16e6,16p,16c7,16p,16c7,16c7,p,16g6,16f#6,16f6,16d#6,16p,16e6,16p,16g#,16a,16c6,16p,16a,16c6,16d6,8p,16d#6,8p,16d6,8p,16c6"],
                ["Donkey Kong", ":d=4,o=5,b=160:2c,8d.,d#.,c.,16b,16c6,16b,16c6,16b,16c6,16b,16c6,16b,16c6,16b,16c6,16b,2c6"],
                ["Pac-Man", ":d=4,o=5,b=112:32b,32p,32b6,32p,32f#6,32p,32d#6,32p,32b6,32f#6,16p,16d#6,16p,32c6,32p,32c7,32p,32g6,32p,32e6,32p,32c7,32g6,16p,16e6,16p,32b,32p,32b6,32p,32f#6,32p,32d#6,32p,32b6,32f#6,16p,16d#6,16p,32d#6,32e6,32f6,32p,32f6,32f#6,32g6,32p,32g6,32g#6,32a6,32p,32b.6"],
                ["The Simpsons", ":d=4,o=5,b=160:c.6,e6,f#6,8a6,g.6,e6,c6,8a,8f#,8f#,8f#,2g,8p,8p"],
                ["Xmen", ":d=4,o=6,b=140:16f#5,16g5,16b5,16d,c#,8b5,8f#5,p,16f#5,16g5,16b5,16d,c#,8b5,8g5,p,16f#5,16g5,16b5,16d,c#,8b5,8d,2p,8c#,8b5,2p,16b5,16e,16f#,16g,f#,8e,8b5,p,16b5,16e,16f#,16g,f#,8e,8c,p,16f#5,16g5,16b5,16d,c#,8b5,8d,2p,8c#,8b5,2p"],
                ["20th Century Fox", ":d=16,o=5,b=140:b,8p,b,b,2b,p,c6,32p,b,32p,c6,32p,b,32p,c6,32p,b,8p,b,b,b,32p,b,32p,b,32p,b,32p,b,32p,b,32p,b,32p,g#,32p,a,32p,b,8p,b,b,2b,4p,8e,8g#,8b,1c#6,8f#,8a,8c#6,1e6,8a,8c#6,8e6,1e6,8b,8g#,8a,2b"],
                ["La La La", ":d=16,o=5,b=140:8f7,8a#6,8c#7,8f7,8c7,8f6,8g#6,8c7,8c#7,8f#6,8a#6,8c#7,8d#7,8g#6,8c7,8d#7,8f7,8a#6,8c#7,8f7,8c7,8f6,8g#6,8c7,8c#7,8f#6,8a#6,8c#7,8d#7,8g#6,8c7,8d#7"],
                ["Take On Me", ":d=16,o=5,b=100:8p,a#,a#,a#,8f#,8d#,8g#,8g#,g#,c6,c6,c#6,d#6,c#6,c#6,c#6,8g#,8f#,8a#,8a#,a#,g#,g#,a#,g#,a#,a#,a#,8f#,8d#,8g#,8g#,g#,c6,c6,c#6,d#6,c#6,c#6,c#6,8g#,8f#,8a#,8a#"],
                ["Barbie Girl", ":d=4,o=5,b=125:8g#,8e,8g#,8c#6,a,p,8f#,8d#,8f#,8b,g#,8f#,8e,p,8e,8c#,f#,c#,p,8f#,8e,g#,f#"],
                ["Pirates of the Caribbean", ":d=4,o=6,b=200:8d,8e,2f,8g,8a,g,f,e,f,g,a,g,p,8f,8g,a,p,8g,8f,e,f,e,d,p,8e,8c,d,8p,p,8d,8e,f,p,8e,8f,g,f,g,a,g,f,d"],
                ["Grease", ":d=8,o=6,b=125:d7,a,2b,a,b,a,4f#.,4a,4g,e,b,a,b,a,4d,a5,a5,b5,b5,c#,c#,d,4d,a,a,4b,b,b,4b,b,b,a,b,a,4f#.,a,a,4b,b,b,4b,b,b,a,b,a,d7"],
                ["Superman", ":d=4,o=6,b=127:8g5,8g5,8g5,c,8c,2g,8p,8g,8a.,16g,8f,1g,8p,8g5,8g5,8g5,c,8c,2g,8p,8g,8a.,16g,8f,8a,2g.,p,8c,8c,8c,2b.,g.,8c,8c,8c,2b.,g.,8c,8c,8c,8b,8a,8b,2c7,8c,8c,8c,8c,8c,2c"],
                ["Harry Potter", ":d=16,o=5,b=125:2p,8p,8b,8e.6,g6,8f#6,4e6,8b6,4a.6,4f#.6,8e.6,g6,8f#6,4d6,8f6,2b,8p,8b,8e.6,g6,8f#6,4e6,8b6,4d7,8c#7,4c7,8g#6,8c.7,b6,8a#6,4f#6,8g6,2e6,8p,8g6,4b6,8g6,4b6,8g6,4c7,8b6,4a#6,8f#6,8g.6,b6,8a#6,4a#,8b,2b6,8p"],
                ["Looney Tunes", ":d=16,o=5,b=160:f7,f7,8e7,8d7,8c7,4a6,8p,8c7,f7,f7,8e7,8d7,8d#7,4e7,8p,8e7,8e7,8c7,8d7,8c7,e7,e7,8c7,8d7,8a6,8c7,8g6,8a#6,8a6,8f6"],
                ["Jurassic Park", ":d=32,o=6,b=28:p,b5,a#5,8b5,16p,b5,a#5,8b5,16p,b5,a#5,16b.5,c#,16c#.,e,8e,16p,d#,b5,16c#.,a#5,16f#5,d#,b5,8c#,16p,f#,b5,16e.,d#,16d#.,c#,8c#."],
                ["Popeye", ":d=8,o=6,b=140:b5,d,d,d,4c,b5,2d,p,d,e,c,e,4g,e,2d,p,d,e,c,e,g,f#,e,d,e,d,b5,g5,d,d,d,d,4e,f#,2g"],
                ["La Cucaracha", ":d=4,o=5,b=100:16d#6,16d#6,16d#6,16g#6,8p,16g#6,16p,16d#6,16d#6,16d#6,16g#6,8p,16g#6"],
                ["Bond 007", ":d=4,o=5,b=320:c,8d,8d,d,2d,c,c,c,c,8d#,8d#,2d#,d,d,d,c,8d,8d,d,2d,c,c,c,c,8d#,8d#,d#,2d#,d,c#,c,c6,1b.,g,f,1g."],
                ["Star Wars", ":d=4,o=5,b=45:32p,32f#,32f#,32f#,8b.,8f#.6,32e6,32d#6,32c#6,8b.6,16f#.6,32e6,32d#6,32c#6,8b.6,16f#.6,32e6,32d#6,32e6,8c#.6"],
                ["A-Team", ":d=8,o=5,b=125:4d#6,a#,2d#6,16p,g#,4a#,4d#.,p,16g,16a#,d#6,a#,f6,2d#6,16p,c#.6,16c6,16a#,g#.,2a#"]
            ]), "RTTTL_MELODY");
            this.setInputsInline(!0);
            this.setOutput(!0, "String")
        }
    };
    /**************************************************************************************************************/
    Blockly.Blocks.actuator_buzzer_rttl_melody_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function () {
            this.setStyle(Blockly.Blocks.actuator.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.ACTUATOR_BUZZER)
                .appendField(new Blockly.FieldImage(img_path + "arduino/actuator_buzzer.svg", 50, 50))
                .appendField(Blockly.Msg.ACTUATOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].digital), "PIN");

            this.appendDummyInput("")
                .appendField(new Blockly.FieldImage(img_path + "arduino/rttl.svg", 30, 30))
                .appendField("RTTTL");
            //  https://picaxe.com/rtttl-ringtones-for-tune-command/
            this.appendDummyInput()
                .appendField(new Blockly.FieldDropdown([
                    ["Tetris", ":d=4,o=5,b=160:e6,8b,8c6,8d6,16e6,16d6,8c6,8b,a,8a,8c6,e6,8d6,8c6,b,8b,8c6,d6,e6,c6,a,2a,8p,d6,8f6,a6,8g6,8f6,e6,8e6,8c6,e6,8d6,8c6,b,8b,8c6,d6,e6,c6,a,a"],
                    ["Mario Bros", ":d=4,o=5,b=100:16e6,16e6,32p,8e6,16c6,8e6,8g6,8p,8g,8p,8c6,16p,8g,16p,8e,16p,8a,8b,16a#,8a,16g.,16e6,16g6,8a6,16f6,8g6,8e6,16c6,16d6,8b,16p,8c6,16p,8g,16p,8e,16p,8a,8b,16a#,8a,16g.,16e6,16g6,8a6,16f6,8g6,8e6,16c6,16d6,8b,8p,16g6,16f#6,16f6,16d#6,16p,16e6,16p,16g#,16a,16c6,16p,16a,16c6,16d6,8p,16g6,16f#6,16f6,16d#6,16p,16e6,16p,16c7,16p,16c7,16c7,p,16g6,16f#6,16f6,16d#6,16p,16e6,16p,16g#,16a,16c6,16p,16a,16c6,16d6,8p,16d#6,8p,16d6,8p,16c6"],
                    ["Donkey Kong", ":d=4,o=5,b=160:2c,8d.,d#.,c.,16b,16c6,16b,16c6,16b,16c6,16b,16c6,16b,16c6,16b,16c6,16b,2c6"],
                    ["Pac-Man", ":d=4,o=5,b=112:32b,32p,32b6,32p,32f#6,32p,32d#6,32p,32b6,32f#6,16p,16d#6,16p,32c6,32p,32c7,32p,32g6,32p,32e6,32p,32c7,32g6,16p,16e6,16p,32b,32p,32b6,32p,32f#6,32p,32d#6,32p,32b6,32f#6,16p,16d#6,16p,32d#6,32e6,32f6,32p,32f6,32f#6,32g6,32p,32g6,32g#6,32a6,32p,32b.6"],
                    ["The Simpsons", ":d=4,o=5,b=160:c.6,e6,f#6,8a6,g.6,e6,c6,8a,8f#,8f#,8f#,2g,8p,8p"],
                    ["Xmen", ":d=4,o=6,b=140:16f#5,16g5,16b5,16d,c#,8b5,8f#5,p,16f#5,16g5,16b5,16d,c#,8b5,8g5,p,16f#5,16g5,16b5,16d,c#,8b5,8d,2p,8c#,8b5,2p,16b5,16e,16f#,16g,f#,8e,8b5,p,16b5,16e,16f#,16g,f#,8e,8c,p,16f#5,16g5,16b5,16d,c#,8b5,8d,2p,8c#,8b5,2p"],
                    ["20th Century Fox", ":d=16,o=5,b=140:b,8p,b,b,2b,p,c6,32p,b,32p,c6,32p,b,32p,c6,32p,b,8p,b,b,b,32p,b,32p,b,32p,b,32p,b,32p,b,32p,b,32p,g#,32p,a,32p,b,8p,b,b,2b,4p,8e,8g#,8b,1c#6,8f#,8a,8c#6,1e6,8a,8c#6,8e6,1e6,8b,8g#,8a,2b"],
                    ["La La La", ":d=16,o=5,b=140:8f7,8a#6,8c#7,8f7,8c7,8f6,8g#6,8c7,8c#7,8f#6,8a#6,8c#7,8d#7,8g#6,8c7,8d#7,8f7,8a#6,8c#7,8f7,8c7,8f6,8g#6,8c7,8c#7,8f#6,8a#6,8c#7,8d#7,8g#6,8c7,8d#7"],
                    ["Take On Me", ":d=16,o=5,b=100:8p,a#,a#,a#,8f#,8d#,8g#,8g#,g#,c6,c6,c#6,d#6,c#6,c#6,c#6,8g#,8f#,8a#,8a#,a#,g#,g#,a#,g#,a#,a#,a#,8f#,8d#,8g#,8g#,g#,c6,c6,c#6,d#6,c#6,c#6,c#6,8g#,8f#,8a#,8a#"],
                    ["Barbie Girl", ":d=4,o=5,b=125:8g#,8e,8g#,8c#6,a,p,8f#,8d#,8f#,8b,g#,8f#,8e,p,8e,8c#,f#,c#,p,8f#,8e,g#,f#"],
                    ["Pirates of the Caribbean", ":d=4,o=6,b=200:8d,8e,2f,8g,8a,g,f,e,f,g,a,g,p,8f,8g,a,p,8g,8f,e,f,e,d,p,8e,8c,d,8p,p,8d,8e,f,p,8e,8f,g,f,g,a,g,f,d"],
                    ["Grease", ":d=8,o=6,b=125:d7,a,2b,a,b,a,4f#.,4a,4g,e,b,a,b,a,4d,a5,a5,b5,b5,c#,c#,d,4d,a,a,4b,b,b,4b,b,b,a,b,a,4f#.,a,a,4b,b,b,4b,b,b,a,b,a,d7"],
                    ["Superman", ":d=4,o=6,b=127:8g5,8g5,8g5,c,8c,2g,8p,8g,8a.,16g,8f,1g,8p,8g5,8g5,8g5,c,8c,2g,8p,8g,8a.,16g,8f,8a,2g.,p,8c,8c,8c,2b.,g.,8c,8c,8c,2b.,g.,8c,8c,8c,8b,8a,8b,2c7,8c,8c,8c,8c,8c,2c"],
                    ["Harry Potter", ":d=16,o=5,b=125:2p,8p,8b,8e.6,g6,8f#6,4e6,8b6,4a.6,4f#.6,8e.6,g6,8f#6,4d6,8f6,2b,8p,8b,8e.6,g6,8f#6,4e6,8b6,4d7,8c#7,4c7,8g#6,8c.7,b6,8a#6,4f#6,8g6,2e6,8p,8g6,4b6,8g6,4b6,8g6,4c7,8b6,4a#6,8f#6,8g.6,b6,8a#6,4a#,8b,2b6,8p"],
                    ["Looney Tunes", ":d=16,o=5,b=160:f7,f7,8e7,8d7,8c7,4a6,8p,8c7,f7,f7,8e7,8d7,8d#7,4e7,8p,8e7,8e7,8c7,8d7,8c7,e7,e7,8c7,8d7,8a6,8c7,8g6,8a#6,8a6,8f6"],
                    ["Jurassic Park", ":d=32,o=6,b=28:p,b5,a#5,8b5,16p,b5,a#5,8b5,16p,b5,a#5,16b.5,c#,16c#.,e,8e,16p,d#,b5,16c#.,a#5,16f#5,d#,b5,8c#,16p,f#,b5,16e.,d#,16d#.,c#,8c#."],
                    ["Popeye", ":d=8,o=6,b=140:b5,d,d,d,4c,b5,2d,p,d,e,c,e,4g,e,2d,p,d,e,c,e,g,f#,e,d,e,d,b5,g5,d,d,d,d,4e,f#,2g"],
                    ["La Cucaracha", ":d=4,o=5,b=100:16d#6,16d#6,16d#6,16g#6,8p,16g#6,16p,16d#6,16d#6,16d#6,16g#6,8p,16g#6"],
                    ["Bond 007", ":d=4,o=5,b=320:c,8d,8d,d,2d,c,c,c,c,8d#,8d#,2d#,d,d,d,c,8d,8d,d,2d,c,c,c,c,8d#,8d#,d#,2d#,d,c#,c,c6,1b.,g,f,1g."],
                    ["Star Wars", ":d=4,o=5,b=45:32p,32f#,32f#,32f#,8b.,8f#.6,32e6,32d#6,32c#6,8b.6,16f#.6,32e6,32d#6,32c#6,8b.6,16f#.6,32e6,32d#6,32e6,8c#.6"],
                    ["A-Team", ":d=8,o=5,b=125:4d#6,a#,2d#6,16p,g#,4a#,4d#.,p,16g,16a#,d#6,a#,f6,2d#6,16p,c#.6,16c6,16a#,g#.,2a#"]
                ]), "RTTTL_MELODY");

            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
}
